export enum ButtonType {
  BLACK = 'black',
  BLACK_SCIENCE = 'blackScience',
  DEFAULT = 'default',
  SPORT = 'sport',
}
